import { getNextEvent } from "core-integration/src/store/events/reducers";
import { formatRawAsLocalI18n } from "core-integration/src/utils/datetime";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { dateLocales } from "../../i18n";
import { CountdownTimer } from "../CountdownTimer";
import DateTimeDeadline from "../DateTimeDeadline";
import { DeadlineDateTimeWrapper, FlexContainer, RoundTitle } from "./styles";

const DeadlineCountdownBox = () => {
  const { t, i18n } = useTranslation();
  const nextEvent = useSelector(getNextEvent);

  const prefersReducedMotion = useMediaQuery(
    "(prefers-reduced-motion: reduce)",
  );

  if (!nextEvent) {
    return null;
  }

  const deadlinePrefix = prefersReducedMotion
    ? t("status.deadlineDateTimeLabel", "Deadline")
    : "";

  const deadlineLocal = formatRawAsLocalI18n(
    nextEvent.deadline_time,
    dateLocales[i18n.language],
  );

  return (
    <FlexContainer>
      <RoundTitle>{nextEvent.name}</RoundTitle>
      <CountdownTimer
        targetDate={new Date(nextEvent.deadline_time)}
        deadlineLabel={`${deadlinePrefix}: ${deadlineLocal}`}
      />
      {!prefersReducedMotion && (
        <DeadlineDateTimeWrapper>
          <DateTimeDeadline
            displayDate={deadlineLocal}
            dateTime={nextEvent.deadline_time}
          />
        </DeadlineDateTimeWrapper>
      )}
    </FlexContainer>
  );
};

export default DeadlineCountdownBox;
